import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getNotifications } from '../../services/NotificationsService';
import { NotificationsResponse } from '../../types/Notifications';

function useGetNotifications(fleetId: string): UseQueryResult<NotificationsResponse> {
  return useQuery(
    ['notifications', fleetId],
    async (): Promise<NotificationsResponse> => getNotifications(fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: 10000,
    },
  );
}

export default useGetNotifications;
